// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"250530df","740":"59638a5f"}[chunkId] + ".chunk.css";
};